import i18n from '@/helper/i18n';

export default function formatDebtorType(value) {
  return i18n.te(`debtors.debtorTypes.${value}`) ? i18n.t(`debtors.debtorTypes.${value}`) : value;
}
